/**
 * Returns the full URL for an image.
 * - If pathOrUrl is already a full URL (http/https), return as-is (e.g. GCS in production).
 * - Otherwise treat as a path and prepend API base (e.g. /uploads/... in local).
 */
export function getImageUrl(pathOrUrl, apiBase = process.env.REACT_APP_API_URL) {
    if (!pathOrUrl) return '';
    if (pathOrUrl.startsWith('http://') || pathOrUrl.startsWith('https://')) {
        return pathOrUrl;
    }
    return apiBase ? `${apiBase}${pathOrUrl}` : pathOrUrl;
}
